import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative mt-1" }
const _hoisted_2 = {
  key: 0,
  class: "block truncate"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "h-5 w-5 text-gray-400",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    })
  ])
], -1)

import { computed } from 'vue';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';


export default {
  __name: 'Select',
  props: {
    options: {
        type: [Array, null],
    },
    selected: {
        type: [String, null],
    },
},
  setup(__props) {

const props = __props;



const selectedName = computed(() => {
    if (!props.selected) return null;
    const option = props.options.find((option) => option.id === props.selected);
    return option ? option.title : null;
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Listbox), {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.$emit('onChange', $event))),
    modelValue: __props.selected
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListboxButton), { class: "Button--no-style relative w-full min-h-[40px] cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm" }, {
          default: _withCtx(() => [
            (_unref(selectedName))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(selectedName)), 1))
              : _createCommentVNode("", true),
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          "leave-active-class": "transition duration-100 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            (__props.options.length)
              ? (_openBlock(), _createBlock(_unref(ListboxOptions), {
                  key: 0,
                  class: "absolute mt-1 z-10 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                      return (_openBlock(), _createBlock(_unref(ListboxOption), {
                        key: option.id,
                        value: option.id,
                        as: "template"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("li", {
                            class: _normalizeClass(["hover:bg-gray-100 cursor-pointer relative select-none py-2 pl-10 pr-4", [
                                option.id === __props.selected
                                    ? 'bg-gray-100 text-primary'
                                    : 'text-gray-900',
                            ]])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass([
                                    option.id === __props.selected ? 'font-medium' : 'font-normal',
                                    'block truncate',
                                ])
                            }, _toDisplayString(option.title), 3)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

}